module.exports = __webpack_public_path__ + "static/12-e14b70bb61c6d17a14cf6dbef1116de5.png";